import { $api } from "../../../store/api/api";

import { EndpointsEnum } from "../../../constants/endpoints";

import { IPostContact, IPostContactBody, IPostContactResponse } from "./post-contact.types";
import { IRestResponse } from "../../../types/response";

export const postContact: IPostContact = async (body: IPostContactBody) => {
    const response = await $api.post<IRestResponse<IPostContactResponse | null>>(`${EndpointsEnum.POST_CONTACT}`, body);

    return response.data;
};
